import { useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as categoryApis from "../../utilities/apis/category"
import Layout from "../../components/Layout"

const Category = () => {
  const navigate = useNavigate()
  const { token } = useSelector(state => state.user)
  const nameRef = useRef(null)
  const params = new URLSearchParams(window.location.search)

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const name = nameRef.current.value
      const payload = { name }

      if (!params.has("id")) {
        const response = await categoryApis.createCategory(token, payload)
        if (!response.status) throw new Error(response.message)

        nameRef.current.value = ""
      } else {
        payload.id = parseInt(params.get("id"))
        const response = await categoryApis.updateCategory(token, payload)
        if (!response.status) throw new Error(response.message)
      }

      alert("Category saved")
      navigate(-1)
    } catch (error) {
      alert(error.message)
    }
  }

  const getCategory = async () => {
    try {
      const response = await categoryApis.getCategory(token, params.get("id"))
      if (!response.status) throw new Error(response.message)

      nameRef.current.value = response.category.name
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (params.has("id")) getCategory()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="w-25 mx-auto">
          <form method="POST" onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex gap-3 align-items-center">
                <button type="button" className="btn btn-secondary rounded-4" onClick={() => navigate(-1)}><i className="bi bi-chevron-left"></i></button>
                <p className="lead text-body-emphasis fw-bold m-0">{params.has("id") ? "Edit" : "Add"} Category</p>
              </div>

              <div className="card rounded-4 shadow-none">
                <div className="card-body py-4">
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <label htmlFor="name" className="form-label">Name</label>
                      <input ref={nameRef} type="text" className="form-control" id="name" placeholder="Name" required />
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button type="submit" className="btn btn-theme rounded-4 w-25">Save</button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </Layout>
  )
}

export default Category
